<template>
    <section id="nova-mais">
    </section>
  </template>
  <script>
  export default {
    name: "BoxIndicacao",
  };
  </script>
  